import { useState } from 'react';
import { toast } from 'sonner';

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle
} from '@/components/ui/alert-dialog';
import { Translator } from 'components/i18n';

interface DMDeleteHistoryDialogProps {
    open: boolean;
    onOpenChange: (open: boolean) => void;
}

export function DMDeleteHistoryDialog({
    open,
    onOpenChange
}: DMDeleteHistoryDialogProps) {
    const [isDeleting, setIsDeleting] = useState(false);

    const handleDeleteAllThreads = async () => {
        setIsDeleting(true);
        toast.loading('Deleting chat history...');

        try {
            const response = await fetch(
                `${window.location.origin}/project/threads/delete-all`,
                {
                    method: 'DELETE',
                    credentials: 'include',
                    headers: { 'Content-Type': 'application/json' }
                }
            );

            if (!response.ok) {
                throw new Error('Failed to delete threads');
            }

            toast.dismiss();
            toast.success('Chat history deleted successfully');
            onOpenChange(false);

            setTimeout(() => {
                window.location.href = '/';
            }, 500);
        } catch (error) {
            toast.dismiss();
            toast.error('Failed to delete chat history');
            console.error('Error deleting threads:', error);
        } finally {
            setIsDeleting(false);
        }
    };

    return (
        <AlertDialog open={open} onOpenChange={onOpenChange}>
            <AlertDialogContent>
                <AlertDialogHeader>
                    <AlertDialogTitle>
                        <Translator path="chat.settings.actions.delete.title" />
                    </AlertDialogTitle>
                    <AlertDialogDescription>
                        <Translator path="chat.settings.actions.delete.description" />
                    </AlertDialogDescription>
                </AlertDialogHeader>
                <AlertDialogFooter>
                    <AlertDialogCancel disabled={isDeleting}>
                        <Translator path="common.actions.cancel" />
                    </AlertDialogCancel>
                    <AlertDialogAction variant="destructive" onClick={handleDeleteAllThreads} disabled={isDeleting}>
                            {isDeleting ? (
                                <Translator path="chat.settings.actions.delete.inProgress" />
                            ) : (
                                <Translator path="common.actions.confirm" />
                            )}
                        </AlertDialogAction>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    );
}
